import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledBar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 60;
  background: ${CSSVars.white};
  border-top: 1px solid ${CSSVars.gray100};
  box-shadow: 0 -8px 24px rgba(16, 24, 40, 0.08);
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  transform: translateY(100%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0;
  pointer-events: none;

  &.visible {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  /* Hide above tablet — desktop has plenty of in-page CTAs */
  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    display: none;
  }

  .inner {
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: 480px;
    margin: 0 auto;
  }

  .microcopy {
    flex: 1;
    font-family: ${CSSVars.secondaryFont};
    font-size: 12px;
    line-height: 1.4;
    color: #4b5563;
    min-width: 0;
  }

  .cta {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 14px;
    color: ${CSSVars.white};
    text-decoration: none;
    padding: 12px 20px;
    border-radius: 999px;
    background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.purple500} 50%, ${CSSVars.blue500} 100%);
    background-size: 200% 100%;
    background-position: 100% 0;
    transition: background-position 0.4s ease, transform 0.15s ease;
    box-shadow: 0 4px 14px rgba(91, 91, 255, 0.3);

    &:active {
      transform: scale(0.97);
    }

    span {
      transition: transform 0.2s ease;
    }
  }
`;
